import React, { useState } from 'react';
import PageTitle from '../components/pagetitle/PageTitle';
import { Link, useNavigate } from 'react-router-dom';
import { useCart } from '../context/CartContext';

function Checkout(props) {
    const { cartItems, getCartTotal, clearCart } = useCart();
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        fullName: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        state: '',
        pincode: '',
        paymentMethod: 'upi'
    });

    const [isProcessing, setIsProcessing] = useState(false);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setIsProcessing(true);
        
        setTimeout(() => {
            clearCart();
            setIsProcessing(false);
            alert('Order placed successfully! Your vouchers will be delivered to your email and dashboard.');
            navigate('/dashboard');
        }, 2000);
    };

    if (cartItems.length === 0) {
        return (
            <div>
                <PageTitle none='none' title='Checkout' />
                <section className="tf-add-nft">
                    <div className="tf-container">
                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                <div className="add-nft-inner" style={{textAlign: 'center', padding: '60px 20px'}}>
                                    <h4 className="title">No items in cart</h4>
                                    <p className="sub" style={{marginBottom: '30px'}}>Add items to your cart before proceeding to checkout.</p>
                                    <Link to="/dt-shop" className="tf-button active">Browse Vouchers</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    return (
        <div>
            <PageTitle none='none' title='Checkout' />

            <section className="tf-add-nft">
                <div className="tf-container">
                    <div className="row">
                        <div className="col-lg-8">
                            <div className="add-nft-inner">
                                <h6 className="title">Billing Information</h6>
                                <p className="sub">Please provide your details to complete the purchase.</p>

                                <form onSubmit={handleSubmit}>
                                    <fieldset>
                                        <label>Full Name *</label>
                                        <input 
                                            type="text" 
                                            name="fullName"
                                            value={formData.fullName}
                                            onChange={handleInputChange}
                                            placeholder="Enter your full name" 
                                            required 
                                        />
                                    </fieldset>

                                    <div className="set-item">
                                        <fieldset>
                                            <label>Email Address *</label>
                                            <input 
                                                type="email" 
                                                name="email"
                                                value={formData.email}
                                                onChange={handleInputChange}
                                                placeholder="your.email@example.com" 
                                                required 
                                            />
                                        </fieldset>
                                        <fieldset>
                                            <label>Phone Number *</label>
                                            <input 
                                                type="tel" 
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleInputChange}
                                                placeholder="+91 XXXXX XXXXX" 
                                                required 
                                            />
                                        </fieldset>
                                    </div>

                                    <fieldset>
                                        <label>Address</label>
                                        <input 
                                            type="text" 
                                            name="address"
                                            value={formData.address}
                                            onChange={handleInputChange}
                                            placeholder="Street address (optional)" 
                                        />
                                    </fieldset>

                                    <div className="set-item">
                                        <fieldset>
                                            <label>City</label>
                                            <input 
                                                type="text" 
                                                name="city"
                                                value={formData.city}
                                                onChange={handleInputChange}
                                                placeholder="City" 
                                            />
                                        </fieldset>
                                        <fieldset>
                                            <label>State</label>
                                            <input 
                                                type="text" 
                                                name="state"
                                                value={formData.state}
                                                onChange={handleInputChange}
                                                placeholder="State" 
                                            />
                                        </fieldset>
                                    </div>

                                    <fieldset>
                                        <label>PIN Code</label>
                                        <input 
                                            type="text" 
                                            name="pincode"
                                            value={formData.pincode}
                                            onChange={handleInputChange}
                                            placeholder="6-digit PIN code" 
                                        />
                                    </fieldset>

                                    <h6 className="title" style={{marginTop: '30px'}}>Payment Method</h6>
                                    <p className="sub">Select your preferred payment method.</p>

                                    <ul className="collection-list">
                                        <li>
                                            <div className="list">
                                                <label style={{display: 'flex', alignItems: 'center', cursor: 'pointer', width: '100%'}}>
                                                    <input 
                                                        type="radio" 
                                                        name="paymentMethod" 
                                                        value="upi"
                                                        checked={formData.paymentMethod === 'upi'}
                                                        onChange={handleInputChange}
                                                        style={{marginRight: '15px'}}
                                                    />
                                                    <div className="infor">
                                                        <p>UPI Payment</p>
                                                        <h6>Pay using Google Pay, PhonePe, Paytm, or any UPI app</h6>
                                                    </div>
                                                </label>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="list">
                                                <label style={{display: 'flex', alignItems: 'center', cursor: 'pointer', width: '100%'}}>
                                                    <input 
                                                        type="radio" 
                                                        name="paymentMethod" 
                                                        value="card"
                                                        checked={formData.paymentMethod === 'card'}
                                                        onChange={handleInputChange}
                                                        style={{marginRight: '15px'}}
                                                    />
                                                    <div className="infor">
                                                        <p>Credit / Debit Card</p>
                                                        <h6>Visa, Mastercard, Rupay accepted</h6>
                                                    </div>
                                                </label>
                                            </div>
                                        </li>
                                        <li>
                                            <div className="list">
                                                <label style={{display: 'flex', alignItems: 'center', cursor: 'pointer', width: '100%'}}>
                                                    <input 
                                                        type="radio" 
                                                        name="paymentMethod" 
                                                        value="netbanking"
                                                        checked={formData.paymentMethod === 'netbanking'}
                                                        onChange={handleInputChange}
                                                        style={{marginRight: '15px'}}
                                                    />
                                                    <div className="infor">
                                                        <p>Net Banking</p>
                                                        <h6>Pay directly from your bank account</h6>
                                                    </div>
                                                </label>
                                            </div>
                                        </li>
                                    </ul>

                                    <div className="bottom-button" style={{marginTop: '30px'}}>
                                        <button 
                                            type="submit" 
                                            className="tf-button active"
                                            disabled={isProcessing}
                                        >
                                            {isProcessing ? 'Processing...' : `Pay ₹${getCartTotal().toFixed(2)}`}
                                        </button>
                                        <Link to="/cart" className="tf-button">Back to Cart</Link>
                                    </div>
                                </form>
                            </div>
                        </div>

                        <div className="col-lg-4">
                            <div className="add-nft-inner" style={{position: 'sticky', top: '100px'}}>
                                <h6 className="title">Order Summary</h6>
                                
                                <div style={{marginBottom: '20px'}}>
                                    {cartItems.map(item => (
                                        <div key={item.id} style={{display: 'flex', gap: '15px', marginBottom: '15px', paddingBottom: '15px', borderBottom: '1px solid #eee'}}>
                                            <div style={{width: '60px', height: '60px', borderRadius: '8px', overflow: 'hidden', border: '1px solid #eee'}}>
                                                <img src={item.image} alt={item.name} style={{width: '100%', height: '100%', objectFit: 'cover'}} />
                                            </div>
                                            <div style={{flex: 1}}>
                                                <p style={{fontSize: '14px', fontWeight: '600', marginBottom: '5px'}}>{item.name}</p>
                                                <p style={{fontSize: '12px', color: '#888'}}>Qty: {item.quantity}</p>
                                            </div>
                                            <div>
                                                <p style={{fontSize: '14px', fontWeight: '600', color: '#FFC107'}}>₹{(parseFloat(item.price.replace(/[^0-9.-]+/g, '')) * item.quantity).toFixed(2)}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>

                                <ul className="collection-list">
                                    <li>
                                        <div className="list">
                                            <div className="infor">
                                                <p>Subtotal</p>
                                            </div>
                                            <div>
                                                <h6>₹{getCartTotal().toFixed(2)}</h6>
                                            </div>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="list">
                                            <div className="infor">
                                                <p>Processing Fee (0.05%)</p>
                                            </div>
                                            <div>
                                                <h6>₹{(getCartTotal() * 0.0005).toFixed(2)}</h6>
                                            </div>
                                        </div>
                                    </li>
                                    <li style={{borderTop: '2px solid #ddd', paddingTop: '15px', marginTop: '15px'}}>
                                        <div className="list">
                                            <div className="infor">
                                                <p style={{fontSize: '18px', fontWeight: '700'}}>Total Amount</p>
                                            </div>
                                            <div>
                                                <h6 style={{fontSize: '24px', fontWeight: '700', color: '#FFC107'}}>₹{(getCartTotal() * 1.0005).toFixed(2)}</h6>
                                            </div>
                                        </div>
                                    </li>
                                </ul>

                                <div style={{marginTop: '20px', padding: '15px', background: '#f8f9fa', borderRadius: '8px'}}>
                                    <p style={{fontSize: '12px', color: '#666', margin: 0, lineHeight: '1.6'}}>
                                        <strong>Secure Payment:</strong> Your payment information is encrypted and secure. Vouchers will be delivered instantly to your email and dashboard after successful payment.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Checkout;
